import angular from 'angular';


export class focus {
  constructor(
    $timeout,
    $window
  ) {
    console.log('app.services.focus created');
    return (id) => {
      // timeout makes sure that it is invoked after any other event has been triggered.
      // e.g. click events that need to run before the focus or
      // inputs elements that are in a disabled state but are enabled when those events
      // are triggered.
      $timeout(() => {
        const element = $window.document.getElementById(id);
        if (element) {
          element.focus();
        }
      });
    };
  }
}

focus.$inject = ['$timeout', '$window'];

export default angular.module('app.services.focus', [])
  .service('focus', focus)
  .name;
